import classNames from 'classnames';
import { FC } from 'react';

import { Breakpoint } from '../../utils/breakpoint';

import { useBreakpoint } from '../../hooks/useBreakpoint';

export interface ITariffCardLabelProps {
  title: string;
  className?: string;
}

export const TariffCardInfoLabel: FC<ITariffCardLabelProps> = ({ className, title }) => {
  const breakpoint = useBreakpoint();

  return (
    <div
      className={classNames(
        'flex items-center justify-center px-4 py-2 bg-[#FFF5F5] text-[#C00000] rounded-md',
        {
          'text-[12px] font-manrope font-medium': breakpoint < Breakpoint.Lg,
          'text-[16px] font-comfortaa font-semibold': breakpoint >= Breakpoint.Lg,
        },
        className,
      )}
      style={{
        minHeight: '32px',
        maxWidth: breakpoint >= Breakpoint.Lg ? '4gi50px' : '200px',
        margin: '0 auto',
      }}
    >
      <p className="text-center">{title}</p>
    </div>
  );
};
